var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeDefasagem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0a99db41b1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.5 37.5 L 337.5 37.5 L 337.5 224 L 37.5 224 Z M 37.5 37.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dcddcf7eb8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 135 249 L 240 249 L 240 270.75 L 135 270.75 Z M 135 249 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0a99db41b1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1b4e8d",
    d: "M 50.558594 37.519531 L 324.433594 37.519531 C 331.554688 37.519531 337.371094 43.34375 337.371094 50.476562 L 337.371094 210.148438 C 337.371094 217.28125 331.554688 223.105469 324.433594 223.105469 L 50.558594 223.105469 C 43.4375 223.105469 37.625 217.28125 37.625 210.148438 L 37.625 50.476562 C 37.625 43.34375 43.4375 37.523438 50.558594 37.523438 Z M 55.621094 55.546875 L 55.621094 205.078125 L 319.375 205.078125 L 319.375 55.546875 Z M 55.621094 55.546875 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dcddcf7eb8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1b4e8d",
    d: "M 145.558594 249.96875 L 229.226562 249.96875 C 234.921875 249.96875 239.585938 254.636719 239.585938 260.34375 L 239.585938 270.722656 L 135.199219 270.722656 L 135.199219 260.34375 C 135.199219 254.636719 139.859375 249.96875 145.558594 249.96875 Z M 145.558594 249.96875 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1b4e8d",
    d: "M 159.660156 221.96875 C 162.535156 228.796875 165.445312 241.351562 159.5 250.621094 L 215.285156 250.621094 C 209.417969 241.53125 211.265625 229.03125 213.839844 221.96875 Z M 159.660156 221.96875 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b4e8d",
    d: "M 151.589844 67.804688 L 223.40625 67.804688 L 223.40625 75.683594 L 151.589844 75.683594 Z M 151.589844 67.804688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b4e8d",
    d: "M 151.589844 184.945312 L 223.40625 184.945312 L 223.40625 192.820312 L 151.589844 192.820312 Z M 151.589844 184.945312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b4e8d",
    d: "M 187.496094 130.3125 C 215.058594 123.105469 214.523438 80.265625 214.523438 80.265625 L 160.472656 80.265625 C 160.472656 80.265625 159.9375 123.105469 187.496094 130.3125 Z M 187.496094 130.3125 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b4e8d",
    d: "M 214.523438 180.359375 C 214.523438 180.359375 215.058594 137.523438 187.496094 130.3125 C 159.9375 137.523438 160.472656 180.359375 160.472656 180.359375 Z M 214.523438 180.359375 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeDefasagem);
export default __webpack_public_path__ + "static/media/icone_defasagem.0280dc67242e3eee95a1c6a1c5f58a85.svg";
export { ForwardRef as ReactComponent };